var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-snackbar.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-snackbar` displays brief messages at the bottom of the screen, typically used to provide feedback
 * about an operation. It can include actions and be dismissible based on the configuration.
 *
 * ### Attributes
 * - `type`: Indicates the category of the snackbar, affecting its appearance and meaning.
 * - `value`: The message content to be displayed in the snackbar.
 * - `action`: Optional text for an action button that can be displayed alongside the message.
 * - `closable`: Determines if the snackbar can be closed by the user.
 *
 * @tag sds-snackbar
 */
let SdsSnackbar = (() => {
    var _SdsSnackbar_type_accessor_storage, _SdsSnackbar_value_accessor_storage, _SdsSnackbar_action_accessor_storage, _SdsSnackbar_closable_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-snackbar')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _action_decorators;
    let _action_initializers = [];
    let _action_extraInitializers = [];
    let _closable_decorators;
    let _closable_initializers = [];
    let _closable_extraInitializers = [];
    var SdsSnackbar = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsSnackbar_type_accessor_storage.set(this, __runInitializers(this, _type_initializers, void 0));
            _SdsSnackbar_value_accessor_storage.set(this, (__runInitializers(this, _type_extraInitializers), __runInitializers(this, _value_initializers, void 0)));
            _SdsSnackbar_action_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _action_initializers, void 0)));
            _SdsSnackbar_closable_accessor_storage.set(this, (__runInitializers(this, _action_extraInitializers), __runInitializers(this, _closable_initializers, void 0)));
            this._snackbarParent = __runInitializers(this, _closable_extraInitializers);
            this._snackbarHeight = 56;
            this.closeAction = () => {
                this.remove();
                if (this._snackbarParent &&
                    this._snackbarParent.querySelectorAll('sds-snackbar').length === 0) {
                    this._snackbarParent.style.transform = '';
                }
                this.updateSnackbarPositions(this._snackbarParent);
            };
        }
        /**
         * The type of the snackbar, affecting its styling and meaning. Possible values:
         * - `'default'`: Standard snackbar.
         * - `'info'`: Snackbar for informational messages.
         * - `'success'`: Snackbar indicating a successful operation.
         * - `'warning'`: Snackbar for warning messages.
         * - `'error'`: Snackbar for error messages.
         *
         * @attr {SnackbarType} type - The category of the snackbar.
         */
        get type() { return __classPrivateFieldGet(this, _SdsSnackbar_type_accessor_storage, "f"); }
        set type(value) { __classPrivateFieldSet(this, _SdsSnackbar_type_accessor_storage, value, "f"); }
        /**
         * The message content displayed in the snackbar.
         *
         * @attr {string} value - The message to be shown in the snackbar.
         */
        get value() { return __classPrivateFieldGet(this, _SdsSnackbar_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsSnackbar_value_accessor_storage, value, "f"); }
        /**
         * Optional text for an action button displayed in the snackbar.
         *
         * @attr {string} action - Text for the action button.
         */
        get action() { return __classPrivateFieldGet(this, _SdsSnackbar_action_accessor_storage, "f"); }
        set action(value) { __classPrivateFieldSet(this, _SdsSnackbar_action_accessor_storage, value, "f"); }
        /**
         * If true, the snackbar is closable by the user.
         *
         * @attr {boolean} closable - Indicates whether the snackbar can be closed.
         */
        get closable() { return __classPrivateFieldGet(this, _SdsSnackbar_closable_accessor_storage, "f"); }
        set closable(value) { __classPrivateFieldSet(this, _SdsSnackbar_closable_accessor_storage, value, "f"); }
        static snackbar(parent, type, value, duration = 3000) {
            const snackbar = document.createElement('sds-snackbar');
            snackbar.setAttribute('type', type);
            snackbar.setAttribute('value', value);
            parent.style.transform = 'translate3d(0, 0, 0)'; // fixing position relative to parent
            parent.append(snackbar);
            setTimeout(() => {
                snackbar.updateSnackbarPositions(parent);
                removeSnackbar();
            }, 0);
            let removeTimeout;
            const removeSnackbar = () => {
                removeTimeout = setTimeout(() => {
                    if (!isMouseOver) {
                        snackbar.remove();
                        if (parent.querySelectorAll('sds-snackbar').length === 0) {
                            parent.style.transform = '';
                        }
                        snackbar.updateSnackbarPositions(parent);
                    }
                }, duration);
            };
            let isMouseOver = false;
            snackbar.addEventListener('mouseenter', () => {
                isMouseOver = true;
                clearTimeout(removeTimeout);
            });
            snackbar.addEventListener('mouseleave', () => {
                isMouseOver = false;
                setTimeout(removeSnackbar, 0);
            });
            return snackbar;
        }
        updateSnackbarPositions(parentElement) {
            const visibleSnackbars = Array.from(parentElement.querySelectorAll('sds-snackbar'));
            if (!visibleSnackbars.length)
                return;
            const lastAddedIndex = visibleSnackbars.length - 1;
            visibleSnackbars.forEach((snackbar, index) => {
                snackbar.style.bottom = (lastAddedIndex - index) * this._snackbarHeight + 24 + 'px';
                snackbar.style.opacity = '1';
            });
        }
        render() {
            this._snackbarParent = this.parentElement;
            return html `
            <div class="${this.getClasses()}">
                ${this.renderType()}
                <div class="sds-snackbar__content">
                    <sds-clipped-text basic text="${this.value}"></sds-clipped-text>
                </div>
                ${this.renderAction()} ${this.renderCloseAction()}
            </div>
        `;
        }
        renderIconType() {
            if (this.type === 'success') {
                return 'check';
            }
            else if (this.type === 'info') {
                return 'information';
            }
            else if (this.type === 'warning') {
                return 'warning';
            }
            else if (this.type === 'error') {
                return 'warning_circle';
            }
            else {
                return '';
            }
        }
        renderType() {
            if (this.type !== 'default') {
                return html `
                <div class="sds-snackbar__type">
                    <sds-icon name="${this.renderIconType()}" size="16"></sds-icon>
                </div>
            `;
            }
        }
        renderAction() {
            if (this.action) {
                return html `
                <sds-button
                    @click="${(e) => this.clickHandler(e)}"
                    class="sds-snackbar__action"
                    label="${this.action}"
                    type="tertiary"
                    size="lg"
                ></sds-button>
            `;
            }
        }
        clickHandler(e) {
            this.dispatchAction(e);
            this.closeAction();
        }
        dispatchAction(e) {
            this.dispatchEvent(new CustomEvent(SdsSnackbar.ACTION_EVENT));
            e.stopPropagation();
        }
        renderCloseAction() {
            if (this.closable) {
                return html `
                <button class="sds-snackbar__close-action" @click="${this.closeAction}">
                    <sds-icon size="16" name="close"></sds-icon>
                </button>
            `;
            }
        }
        getClasses() {
            return classMap({
                'sds-snackbar': true,
                'sds-snackbar--default': this.type == 'default',
                'sds-snackbar--success': this.type == 'success',
                'sds-snackbar--info': this.type == 'info',
                'sds-snackbar--warning': this.type == 'warning',
                'sds-snackbar--error': this.type == 'error',
            });
        }
    };
    _SdsSnackbar_type_accessor_storage = new WeakMap();
    _SdsSnackbar_value_accessor_storage = new WeakMap();
    _SdsSnackbar_action_accessor_storage = new WeakMap();
    _SdsSnackbar_closable_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSnackbar");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [property({ type: String })];
        _value_decorators = [property({ type: String })];
        _action_decorators = [property({ type: String })];
        _closable_decorators = [property({ type: Boolean, attribute: 'closable' })];
        __esDecorate(_classThis, null, _type_decorators, { kind: "accessor", name: "type", static: false, private: false, access: { has: obj => "type" in obj, get: obj => obj.type, set: (obj, value) => { obj.type = value; } }, metadata: _metadata }, _type_initializers, _type_extraInitializers);
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, _action_decorators, { kind: "accessor", name: "action", static: false, private: false, access: { has: obj => "action" in obj, get: obj => obj.action, set: (obj, value) => { obj.action = value; } }, metadata: _metadata }, _action_initializers, _action_extraInitializers);
        __esDecorate(_classThis, null, _closable_decorators, { kind: "accessor", name: "closable", static: false, private: false, access: { has: obj => "closable" in obj, get: obj => obj.closable, set: (obj, value) => { obj.closable = value; } }, metadata: _metadata }, _closable_initializers, _closable_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSnackbar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.ACTION_EVENT = 'sds.snackbar.action';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSnackbar = _classThis;
})();
export { SdsSnackbar };
// eslint-disable-next-line @typescript-eslint/unbound-method
window['sdsSnackbar'] = SdsSnackbar.snackbar;
